import React, { useState } from 'react';
import { Spin, Alert } from 'antd';
import { usePW9337Query } from './hooks/usePW9337Query';
import QueryParams from './components/QueryParams';
import ResultTable from './components/ResultTable';
import type { QueryRequest } from '../../services/pw9337Api';
import './PW9337Form.css';

const PW9337Form: React.FC = () => {
  const { loading, result, queried, noData, bonusCodes, bonusCodesLoading, runQuery } = usePW9337Query();

  const [bonusCode, setBonusCode] = useState('');
  const [empFrom, setEmpFrom] = useState('');
  const [empTo, setEmpTo] = useState('');
  const [deptFrom, setDeptFrom] = useState('');
  const [deptTo, setDeptTo] = useState('');
  const [deptLevel, setDeptLevel] = useState(1);
  const [companyType, setCompanyType] = useState(1);
  const [thanks, setThanks] = useState('* 感謝您的努力 !! *');

  const handleQuery = () => {
    const req: QueryRequest = {
      bonusCode: bonusCode.trim(),
      empFrom: empFrom.trim(),
      empTo: empTo.trim() || 'zzzzzzzz',
      deptFrom: deptFrom.trim(),
      deptTo: deptTo.trim() || 'zzzz',
      deptLevel,
      companyType,
      thanks: thanks.trim(),
    };
    runQuery(req);
  };

  return (
    <Spin spinning={loading}>
      <div className="pw9337-container max-w-7xl mx-auto p-4">
        <h2 className="text-xl font-bold mb-4">
          個人獎金明細表 (pw9337f1)
        </h2>

        <QueryParams
          bonusCode={bonusCode}
          empFrom={empFrom}
          empTo={empTo}
          deptFrom={deptFrom}
          deptTo={deptTo}
          deptLevel={deptLevel}
          companyType={companyType}
          thanks={thanks}
          loading={loading}
          bonusCodes={bonusCodes}
          bonusCodesLoading={bonusCodesLoading}
          onBonusCodeChange={setBonusCode}
          onEmpFromChange={setEmpFrom}
          onEmpToChange={setEmpTo}
          onDeptFromChange={setDeptFrom}
          onDeptToChange={setDeptTo}
          onDeptLevelChange={setDeptLevel}
          onCompanyTypeChange={setCompanyType}
          onThanksChange={setThanks}
          onQuery={handleQuery}
        />

        {queried && !noData && result && (
          <ResultTable result={result} />
        )}

        {queried && noData && (
          <Alert
            message="查無資料"
            description="查無符合條件的獎金資料！請確認篩選條件是否正確。"
            type="info"
            showIcon
          />
        )}
      </div>
    </Spin>
  );
};

export default PW9337Form;
